import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Page, { PageSection } from 'cityads-v3/components/Page'
import Balaclava from 'cityads-v3/components/Balaclava';
import ContactFormPageSection from 'cityads-v3/components/Forms/ContactFormPageSection';
import DownloadFileItem from 'cityads-v3/components/DownloadFileItem';
import Typography from '@mui/material/Typography'

@connect()
export default class Policy extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
  }

  render() {
    return (
      <>
        <Balaclava
          menuValue = {'policy'}
        />

        <Page
          title           = "Политика в отно&shy;шении персо&shy;наль&shy;ных данных"
          backgroundColor = "#469ddf"
          backgroundImage = {require('../Contacts/bg.jpg')}
          pageTitle       = "Политика в отношении персональных данных"
          pageDescription = "Политика CityAds Media в отношении персональных данных"
          pageKeywords    = "Политика компании, CityAds Media, персональные данные"
        >
          <PageSection
            data-as-is={true}
            title="О политике"
          >
            <Typography variant="body1">
              Группа компаний CityAds Media соблюдает применимое законодательство в отношении обработки персональных
              данных. Политика в отношении обработки персональных данных является документами, определяющим политику
              соответствующей компании группы в отношении обработки персональных данных, а также содержит сведения о
              реализуемых компаниями группы требованиях к защите персональных данных.
            </Typography>

            <DownloadFileItem
              url   = "/static/documents/policy/personal-data-policy-Smart-Finance-ru.pdf"
              title = "Политика ООО «Смарт Финанс» в отношении обработки персональных данных"
              size  = {283098}
            />

            <DownloadFileItem
              url   = "/static/documents/policy/personal-data-policy-Firano-Finance-ru.pdf"
              title = "Политика ООО «Фирано Финанс» в отношении обработки персональных данных"
              size  = {277067}
            />

            <DownloadFileItem
              url   = "/static/documents/policy/personal-data-policy-Utheram-ru.pdf"
              title = "Политика «Ютерам Трейдинг Лимитед» в отношении обработки персональных данных"
              size  = {272738}
            />
          </PageSection>

          <ContactFormPageSection />
        </Page>
      </>
    );
  }
}
